import { AppLanguage, createEntitySliceSelectors, ICountryListItemTranslated, mapToTranslatedCountries, ICurrencyListItemTranslated, mapToTranslatedCurrencies, createVoidSliceSelectors } from '@aston/foundation';
import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { mapToUserAvatar } from '@aston/user-badge';

import { IAppState } from './state';
import { FeatureName } from './feature';


export const selectState: MemoizedSelector<object, IAppState> = createFeatureSelector<IAppState>(FeatureName);

const getIsFinished = (state: IAppState): boolean => state.isFinished;
export const selectIsInitFinished = createSelector(selectState, getIsFinished);

export const {
	selectIsLoading: selectAppIsLoading,
	selectError: selectAppError
} = createVoidSliceSelectors(createSelector(selectState, state => state.app));

export const {
	selectEntity: selectConfig,
	selectIsLoading: selectConfigIsLoading,
	selectError: selectConfigError
} = createEntitySliceSelectors(createSelector(selectState, state => state.config));

export const {
	getEntity: getFactorConfig,
	selectEntity: selectFactorConfig,
	selectIsLoading: selectFactorConfigIsLoading,
	selectError: selectFactorConfigError
} = createEntitySliceSelectors(createSelector(selectState, state => state.factorConfig));

export const getValidatorsLoaded = (state: IAppState): boolean => state.validatorsLoaded;
export const selectValidatorsLoaded = createSelector(selectState, state => getValidatorsLoaded(state));

export const getIsScrolling = (state: IAppState): boolean => state.isScrolling;
export const selectIsScrolling = createSelector(selectState, state => getIsScrolling(state));

export const getCountries = (state: IAppState, lang: AppLanguage): ICountryListItemTranslated[] => {
	const countries = state.factorConfig?.entity?.countries;
	return mapToTranslatedCountries(countries, lang);
};
export const selectCountries = (lang: AppLanguage) => createSelector(selectState, state => getCountries(state, lang));

export const getCurrencies = (state: IAppState, lang: AppLanguage): ICurrencyListItemTranslated[] => {
	const countries = state.factorConfig?.entity?.currencies;
	return mapToTranslatedCurrencies(countries, lang);
};
export const selectCurrencies = (lang: AppLanguage) => createSelector(selectState, state => getCurrencies(state, lang));

export const {
	selectEntity: selectUser,
	selectIsLoading: selectUserIsLoading,
	selectError: selectUserError
} = createEntitySliceSelectors(createSelector(selectState, state => state.user));

export const selectCurrentUserIsSupport = createSelector(selectUser, state => state?.isSupport);
export const selectCurrentUserAvatar = createSelector(selectUser, state => mapToUserAvatar(state.fullName));

export const {
	selectEntity: selectSalesConditionsDocument,
	selectIsLoading: selectSalesConditionsDocumentIsLoading,
	selectError: selectSalesConditionsDocumentError
} = createEntitySliceSelectors(createSelector(selectState, state => state.salesConditions));
